import { IPayload } from '@network/models/global.model'
import { IGetWebSocketDataParams } from '@network/models/web-socket-data.model'
import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'

export class WebSocketDataApi {
  constructor(private axios: AxiosService) {}

  getWebSocketData = async (params?: IGetWebSocketDataParams) => {
    const response = await this.axios.get<IPayload<any>>(
      Endpoints.getWebSocketData,
      params,
    )
    return response
  }
}
